<div class="root-header" id="root-header">
  <div class="root-header__container">
    <div class="root-header__logo">
      <img
        #logo
        src="assets/img/comreg-logo_2024_english_irish_white_text_horizontal.svg"
        class="root-header__logo--image-horizontaltext"
        alt="Commission for Communications Regulation"
        (click)="navigateHome()"
      />
    </div>
    <div class="root-header__title" [class.root-header__title--right]="hideMenu">
      <ng-content select="application-name"></ng-content>
    </div>
    <div class="root-header__nav-container" [class.nav-spacer]="!hideMenu">
      <ng-content select="top-menu"></ng-content>
    </div>
  </div>
  @if (!hideMenu) {
    <div class="root-header__accent-stripe" [class.root-header__accent-stripe--admin]="isSuperUser"></div>
    <div class="root-header__menu-bar">
      <div class="menu-content">
        <div class="sub-menu-account-name-text" [style.--offset]="logoOffset + 'px'">
          {{ accountName }}
        </div>
        <ng-content select="menu-sub-items"></ng-content>
      </div>
      <div class="menu-account-name">
        <div class="menu-account-name--text"><span *ngIf="role">{{ role }}: </span>{{ accountName }}</div>
      </div>
    </div>
  }
</div>
